import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SolutionFormInterface } from '../modules/SolutionXPLR/SolutionXPLRInterfaces';

interface SolutionFormState {
  formData: SolutionFormInterface;
  isFromDraft: boolean;
}

const initialState: SolutionFormState = {
  formData: {
    name: '',
    description: '',
    business_objectives: '',
    taxonomy: [],
    industry: [],
    search: false,
    best_practice: false,
    dataSources: [],
    technology: [],
  },
  isFromDraft: false,
};

const solutionFormSlice = createSlice({
  name: 'solutionForm',
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<SolutionFormInterface>) => {
      state.formData = action.payload;
      state.isFromDraft = true;
    },
    resetFormData: (state) => {
      state.formData = initialState.formData;
      state.isFromDraft = false;
    },
  },
});

export const { setFormData, resetFormData } = solutionFormSlice.actions;
export default solutionFormSlice.reducer;
